import {
  FaHtml5,
  FaCss3Alt,
  FaSass,
  FaJs,
  FaReact,
  FaNode,
  FaNpm,
  FaAws,
  FaPython,
  FaDocker,
  FaGithub,
} from "react-icons/fa";
import {
  SiFirebase,
  SiTerraform,
  SiGatsby,
  SiGraphql,
  SiReact,
  SiPnpm,
  SiYarn,
  SiJirasoftware,
  SiConfluence,
} from "react-icons/si";
import { AiOutlineDatabase } from "react-icons/ai";
import { VscCode } from "react-icons/vsc";

import { MdApi } from "react-icons/md";
export const professionalProjects = [
  {
    title: "FULL STACK REACT DEVELOPER",
    compnay: "ICF, Rockville",
    location: "Rockville, MD",
    timeline: "JULY 2021 – Present",
    description:
      "Built scalable full-stack web and mobile applications using React, GraphQL, AWS, and Terraform—enhancing performance, accessibility, deployment speed, and user experience across platforms.",
    fullDescription:
      "<p>Develop and maintain a React-based intranet web application and CMS.Support a <strong>Gatsby.js</strong> public-facing web application, an internal <strong>React, Javascript (ES6)</strong> CMS, and a <strong>serverless GraphQL API</strong>.<br/>Construct and optimize <strong>GraphQL queries and mutations</strong> for efficient data retrieval.Enhance error handling to improve client UX and server-side debugging.<br/>Manage and create Infrastructure as Code (IaC) to manage <strong>AWS infrastructure</strong> using <strong>Terraform</strong> for scalable deployments.<br/>Collaborate with cross-functional teams to deliver high-quality software solutions.<br/>Design and implement a serverless GraphQL API to streamline data access.<br/>Author comprehensive documentation for onboarding and maintainability.Write clean, easy-to-understand code following best practices.<br/>Demonstrate expertise in AWS services including CloudFront, Lambda, IAM, S3, SQS, SNS,and Cognito.<br/>Utilize hands-on experience with CI/CD pipelines and tools such as GitHub Actions.<p>",
    tech: "React, GraphQL, Gatsby.js, Terraform, AWS",
  },
  {
    title: "WEB DEVELOPER INTERN",
    company: "University of Bridgeport, CT (student employee)",
    location: "Bridgeport, CT",
    timeline: "SEPETEMBER 2019 – MAY 2021",
    description:
      "Resolved 100+ full-stack support tickets with 95% first-contact resolution, while developing and maintaining PHP, MySQL, and Drupal-based web apps to improve tool usability by 30%.",
    tech: "PHP, MySQL, Drupal, JavaScript, CSS",
    fullDescription:
      "<p>Built and maintained web apps with PHP, MySQL, JS, HTML/CSS, and Drupal.Ensure website availability and optimal performance.<br/>Handle support tickets and resolve issues to ensure user satisfaction.</p>",
  },

  {
    title: "SOFTWARE ENGINEER INTERN",
    company: "Fashion Entertainment Media",
    location: "Remote, USA",
    timeline: "JULY 2020 – MAY 2021",
    description:
      "Led full-stack development of a cross-platform React Native app with secure AWS-backed user management and dynamic scheduling features, accelerating delivery by 30% and scaling for 1,000+ users.",

    tech: "React Native, Node.js, REST API",
    fullDescription:
      "<p>Develop a React Native app for Android and iOS, enabling users to schedule appointmentswith various service providers.<br/>Allow artists to register and offer services through the app.Work as a full stack developer, handling both frontend & backend (RESTAPI) components.<br/>Led a team of 5, using Agile methodologies to manage sprints and deliverables.<br/>Publish the app on the Google Play Store, ensuring it meets approval criteria.<br/>Utilize AWS infrastructure for scalable deployments.<br/>Implement secure login functionality and manage MySQL databases.<br/>Develop an interactive app that toggles between user and artist profiles based on business logic.</p>",
  },
];
export const academicProjects = [
  {
    title: "Analysis of Happiness (Big Data)",
    description:
      "Conducted big data analysis using Hadoop tools to correlate national happiness with freedom and economy metrics.",
    tech: "Hadoop, Spark, Hive, Pig, GCP",
    fullDescription:
      "<p>Used Big data and the Hadoop system to find out the correlation between freedom and happiness rankof countries and also the economy and happiness rank of the country.<br/>Spark is used to find out the correlation between the attributes and results for happiness rank andeconomy was -0.7930 and happiness rank and freedom was -0.53.<br/>Along with this other analysis is also done using different techniques such as MapReduce, Pig, Hive, and GCP</p>",
  },
  {
    title: "Wildfire Intensity Prediction",
    description:
      "Built a decision tree classifier to predict wildfire intensity with 99.35% accuracy.",
    tech: "Python, Scikit-learn, Data Preprocessing",
    fullDescription:
      "<p>The intensity of the wildfire is predicted using data mining techniques.For this prediction Decision tree classification achieved prediction accuracy of 0.9935.<br/>We have to give the attributes such as Humidity, Temperature, Drought code, and Area burnt.<br/> Based onthese values it will predict the intensity of that wildfire.<br/>For these the decision tree techniques in Python. The Data preprocessing also is done using python.</p>",
  },
  {
    title: "DATA VISUALIZATION USING PYTHON",

    description:
      "Created a Tkinter-based Python app to visualize Olympic data, showing gender-wise winners by sport and season using interactive bar charts.",
    tech: "Python, Scikit-learn, Data Preprocessing",
    fullDescription:
      "<p>Built a Desktop application to visualize dataset by selecting different attributes for dataset.<br/>For this visualization python GUI (Graphical User interface) tkinter toolkit is used.<br/>Olympic dataset is used of size 31165*9 (summer Olympics) and 5770*9 (winter Olympics)For e.g., if you select the summer term and the particular game played in Olympics and the genderthen this will give the bar graph for count of female and male who has won in that game in summerOlympics.</p>",
  },
];

export const professionalCertification = [
  {
    title: "AWS Certified AI Practitioner",
    link: "https://www.credly.com/badges/59bf68e0-f123-4a0e-90f5-3951a5c93c89",
    issuedDate: "June 21,2025",
    expiryDate: "June 21,2028",
    icon: "/aws_ai_practitioner.png",
    issuer: "Amazon Web Services",
    img: "/aws_ai_practitioner.png",
    date: "2025-06-21",
  },
  {
    title: "HashiCorp Certified: Terraform Associate (003)",
    link: "https://www.credly.com/badges/efcb88ff-ef2a-4743-91b5-910b77000530/public_url",
    issuedDate: "May 17,2025 ",
    expiryDate: "May 17,2027",
    icon: "/TerraformAssociate.png",
    issuer: "HashiCorp",
    img: "/hashicorp_associate_certi_logo.png",
    date: "2025-05-17",
  },
  {
    title: "AWS Certified Developer – Associate",
    link: "https://www.credly.com/badges/1287568c-f400-4870-8a5b-9b7c5dc26341/linked_in_profile",
    issuedDate: "May 10, 2023",
    expiryDate: "June 21,2028",
    icon: "/aws_DeveloperAssociate.png",
    issuer: "Amazon Web Services",
    img: "/aws_DeveloperAssociate.png",
    date: "2023-05-10",
  },
  {
    title: "AWS Certified Cloud Practitioner",
    link: "https://www.credly.com/badges/d00c9567-79d1-4d72-99e4-2f5d51ac2cb1/linked_in_profile",
    issuedDate: "April 21, 2022",
    expiryDate: "June 21,2028",
    icon: "/aws_CloudPractitioner.png",
    issuer: "Amazon Web Services",
    img: "/aws_CloudPractitioner.png",
    date: "2022-04-21",
  },
];

export const techStack = [
  // Frontend
  "React",
  "HTML5",
  "CSS",
  "JavaScript (ES6)",
  "Material UI",
  "Gatsby",
  "TailWind CSS",

  // Backend & APIs
  "Node.js",
  "REST API",
  "GraphQL",
  "PHP",
  "MySQL",

  // DevOps / Infrastructure
  "AWS",
  "Terraform",
  "CI/CD",
  "GitHub Actions",

  // Tools & Platforms
  "GitHub",
  "VS Code",
  "JIRA",
  "Confluence",
  "Drupal",

  // Mobile
  "React Native",
];
export const hobbies = [
  {
    title: "Running | Half Marathoner",
    description:
      "Currently training for a half marathon. Running keeps me energized and focused!",
    imageUrl: "/running.jpeg", // Ad d your image path here
    socialMediaUrl: "https://www.instagram.com/runwithpranjal/",
  },
  {
    title: "Craft Crocheting",
    description:
      "A relaxing hobby where I create beautiful and unique handmade crochet pieces.",
    imageUrl: "/crocheting.png", // Add your image path here
    socialMediaUrl: "https://www.instagram.com/kalanjal_/",
  },
  {
    title: "Reading",
    description:
      "I love diving into a good book, whether it’s fiction, non-fiction, or technical reading.",
    imageUrl: "/reading.png", // Add your image path here
  },
  // {
  //   title: "Baking",
  //   description:
  //     "Baking allows me to express creativity and share delicious treats with friends and family.",
  //   imageUrl: "/images/baking.jpg", // Add your image path here
  // },
];

export const educationDetails = [
  {
    degree: "Masters in Computer Science",
    institution: "University of Bridgeport",
    date: "May 2021",
  },
  {
    degree: "Bachelors in Computer Engineering",
    institution: "Terna Engineering College",
    date: "May 2019",
  },
];

export const techstackWlogo = [
  // 🟦 Frontend
  {
    icon: <FaHtml5 />,
    label: "HTML5",
    experience: "4+ years",
    usage: "Semantic markup, accessibility-first approach",
    category: "Frontend",
  },
  {
    icon: <FaCss3Alt />,
    label: "CSS3",
    experience: "4+ years",
    usage: "Flexbox, Grid, media queries, animations",
    category: "Frontend",
  },
  {
    icon: <FaSass />,
    label: "SASS",
    experience: "4+ years",
    usage: "Variables, mixins, nesting for scalable CSS",
    category: "Frontend",
  },
  {
    icon: <FaJs />,
    label: "JavaScript",
    experience: "4+ years",
    usage: "DOM manipulation, ES6+, async/await, modules",
    category: "Frontend",
  },
  {
    icon: <FaReact />,
    label: "ReactJS",
    experience: "4+ years",
    usage: "SPA, hooks, router, component-based architecture",
    category: "Frontend",
  },
  {
    icon: <SiReact />,
    label: "React Native",
    experience: "2 year",
    usage: "Cross-platform mobile apps, navigation, styling",
    category: "Frontend",
  },
  {
    icon: <SiGatsby />,
    label: "Gatsby",
    experience: "4+ year",
    usage: "Static site generation, GraphQL data layer",
    category: "Frontend",
  },

  // 🟩 Backend
  {
    icon: <FaNode />,
    label: "NodeJS",
    experience: "4+ years",
    usage: "Express.js, API design, middleware, auth",
    category: "Backend & APIs",
  },
  {
    icon: <SiGraphql />,
    label: "GraphQL",
    experience: "4+ years",
    usage: "Apollo, schema design, query optimization",
    category: "Backend & APIs",
  },
  {
    icon: <MdApi />,
    label: "RESTful API",
    experience: "4+ years",
    usage: "CRUD endpoints, auth, HTTP standards",
    category: "Backend & APIs",
  },
  {
    icon: <AiOutlineDatabase />,
    label: "SQL & NoSQL",
    experience: "4 years",
    usage: "PostgreSQL, MongoDB, indexing, queries",
    category: "Backend & APIs",
  },
  {
    icon: <FaPython />,
    label: "Python",
    experience: "2 years",
    usage: "Scripting, data processing, backend logic",
    category: "Backend & APIs",
  },

  // ⚙️ DevOps
  {
    icon: <FaAws />,
    label: "AWS",
    experience: "4+ years",
    usage: "S3, CI/CD, Lambda, API Gateway, and more",
    category: "Cloud & DevOps",
  },
  {
    icon: <SiTerraform />,
    label: "Terraform",
    experience: "1 year",
    usage: "Infrastructure-as-code for AWS environments",
    category: "Cloud & DevOps",
  },
  // {
  //   icon: <FaDocker />,
  //   label: "Docker",
  //   experience: "1.5 years",
  //   usage: "Containerization, Docker Compose, local dev",
  //   category: "DevOps",
  // },

  // 🧰 Tools
  {
    icon: <FaNpm />,
    label: "NPM",
    experience: "4 years",
    usage: "Package management, scripts, dependency control",
    category: "Tools",
  },
  {
    icon: <SiPnpm />,
    label: "PNPM",
    experience: "2 years",
    usage: "Faster, disk-efficient Node package manager",
    category: "Tools",
  },
  {
    icon: <SiYarn />,
    label: "Yarn",
    experience: "2 years",
    usage: "Project dependency and workspace management",
    category: "Tools",
  },
  {
    icon: <FaGithub />,
    label: "GitHub",
    experience: "4+ years",
    usage: "Version control, collaboration, pull requests",
    category: "Tools",
  },
  {
    icon: <FaGithub />,
    label: "GitHub Actions",
    experience: "4+ years",
    usage: "CI/CD pipelines, build/deploy workflows",
    category: "Tools",
  },
  {
    icon: <VscCode />,
    label: "VS Code",
    experience: "4+ years",
    usage: "Main development environment, extensions, debugging",
    category: "Tools",
  },

  // 🧠 Collaboration
  {
    icon: <SiJirasoftware />,
    label: "Jira",
    experience: "4+ years",
    usage: "Agile boards, sprint tracking, task planning",
    category: "Collaboration",
  },
  {
    icon: <SiConfluence />,
    label: "Confluence",
    experience: "4+ years",
    usage: "Documentation, specs, meeting notes",
    category: "Collaboration",
  },
];
